module.exports = "/work-site/img/device.63c22bd5.png";